import { Link as NLink } from "react-router-dom";

export const Link = ({ icon, text, href }) => {
  return (
    <NLink to={href} className="link-btn">
      {icon && <span>{icon}</span>}
      <span>{text}</span>
    </NLink>
  );
};

export const Link2 = ({ text, icon, type, href }) => {
  return (
    <NLink to={href} className={"link2-btn" + (type ? ` ${type}` : "")}>
      {icon && <span>{icon}</span>}
      <span>{text}</span>
    </NLink>
  );
};


export const BtnLink = ({ text, icon, type, onClick }) => {
  return (
    <button onClick={onClick} className={"link2-btn" + (type ? ` ${type}` : "")}>
      {icon && <span>{icon}</span>}
      <span>{text}</span>
    </button>
  );
};
